import React from "react";
import PropTypes from "prop-types";
import { Accordion as NBAccordion } from "./NBAccordion";
import { extractNativeProps } from "~/native-ui/utils";

import { AccordionItem } from "./AccordionItem";

import pick from "lodash/pick";
import omit from "lodash/omit";

const propTypes = {
    allowToggle: PropTypes.bool,
    allowMultiple: PropTypes.bool,
    shouldOpen: PropTypes.func,
    openItems: PropTypes.arrayOf(PropTypes.number),
    setOpenItems: PropTypes.func,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOf([ PropTypes.node, PropTypes.string ]).isRequired,
            body: PropTypes.oneOf([ PropTypes.node, PropTypes.string ])
        })
    )
}


const defaultProps = {
    items: [],
    openItems: undefined,
    setOpenItems: undefined,
}

const extractAccordionProps = (props) => {
    return omit(pick(props, Object.keys(propTypes)), Object.keys(defaultProps))
}

export class Accordion extends React.PureComponent {
    static propTypes = propTypes


    static defaultProps = defaultProps


    renderChildItem = (props, index) => {
        return <AccordionItem {...props}  index={index} />
    }

    
    renderChildren () {
        return this.props.items.map(this.renderChildItem)
    }


    render() {
        const [ tokenProps, props ] = extractNativeProps(this.props);
        const accordionProps = {
            ...extractAccordionProps( props ),
            index: props.openItems,
            onChange: props.setOpenItems,
            style: props.style,
        }

        return (
            <NBAccordion { ...tokenProps } { ...accordionProps }>
                {this.renderChildren(props)}
                {props.children}
            </NBAccordion>
        )
    }
}

Accordion.Item = AccordionItem